import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { isEmpty } from 'ramda';
import { withTagDefaultProps } from 'hoc';
import { withServiceConsumer } from 'services/Context';
import { SliderWrap, Slider, SliderList, SliderItem } from 'templates/Slider';
import { Referal } from 'templates/Referal';
import { getTransactions } from 'services/Web3';
import translation from 'locales';
import { useSelector } from 'react-redux';

const propTypes = {
  referals: PropTypes.objectOf(PropTypes.any).isRequired,
};

const ReferalSlider = ({ referals, t, totalRefs }) => {
  const locale = useSelector((state) => state.web3.locale);

  const strings = translation[locale];
  return (
    <SliderWrap
      title={t(strings['your.reffs'])}
      subtitle={t(strings['your.invitees'])}
      subject={`${totalRefs === undefined ? 0 : totalRefs} ${t(strings['participants'])}`}
    >
      {!isEmpty(referals) && (
        <Slider controls>
          <SliderList>
            {referals?.referrals.map((item, index) => (
              <SliderItem key={index}>
                <Referal name={''} bonus={referals?.bonuses[index] / 1e18} />
              </SliderItem>
            ))}
          </SliderList>
        </Slider>
      )}
    </SliderWrap>
  );
};

ReferalSlider.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => {
  const { getStoreItem } = ownProps.service;
  return {
    totalRefs: state?.web3?.referalInfo?.referrals?.length,
    referals: state.web3.referalInfo,
  };
};

export default compose(
  withServiceConsumer,
  withTagDefaultProps(mapStateToProps, null)
)(ReferalSlider);
